<template>
  <div class="scroll-up">
    <router-link @click.native="moveToTop" to>
      <span>
        <font-awesome-icon :icon="['fas', 'chevron-up']" class="scroll-icon" />
      </span>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "ScrollUpButton",
  data() {
    return {
      moveDown: true
    };
  },
  methods: {
    moveToTop() {
      let top = document.querySelector("#home-header").clientHeight;

      window.scroll({
        top,
        left: 0,
        behavior: "smooth"
      });

      this.moveDown = !this.moveDown;
    }
  }
};
</script>
